import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  '& .MLVParicipationSectionSpacing': {
    padding: theme.spacing(16, 0),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(8, 0),
    },
  },
  '& .MLVDivider': {
    backgroundColor: theme.palette.divider[5],
    borderColor: theme.palette.divider[5],
  },
  '& .MLVSpacingMobile': {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 0),
    },
  },
}));
